<template>
    <div class="counter">
        <button @click.prevent="setQuantity(+quan-1)" :disabled="quan <= 1" class="counter__minus"></button>
        <input class="counter__input" type="number" v-model="quan" :readonly="readonly" />
        <button @click.prevent="setQuantity(+quan+1)" class="counter__plus"></button>
    </div>
</template>

<script>

import { ref, watch } from 'vue';

export default {
    name: 'QuantityControl',
    props : {
        modelValue : {
            type : Number,
            default : 1,
        },
        readonly : {
            type : Boolean,
            default : false,
        },
        min : {
            type : [ String, Number, ],
            default : 1,
        },
        max : {
            type : [ String, Number, ],
            default : 9999,
        },
    },
    setup (props, { emit }) {
        let quan = ref(props.modelValue);

        watch(() => props.modelValue, () => {
            quan.value = props.modelValue;
        });

        watch(quan, () => {
            setQuantity(quan.value);
            emit('update:modelValue', quan.value);
            emit('change', quan.value);
        });

        const setQuantity = quantity => {
            if (quantity < props.min) {
                quantity = props.min;
            }
            if (quantity > props.max) {
                quantity = props.max;
            }
            if (quantity != props.quan) {
                quan.value = quantity;
            }
        }

        return {
            setQuantity,
            quan,
        };
    },
}
</script>
